import produce from 'immer';
import { AnyAction } from 'redux';
import { defaultMeta } from '../../constants/dataListMeta';
import { IMeta } from '../../interfaces';
import {
  ADD_ACCOUNT_COLLECTION_NFT,
  CLEAR_ACCOUNT_COLLECTION_NFTS_DATA,
  DELETE_ACCOUNT_COLLECTION_NFT,
  FETCH_ACCOUNT_COLLECTION_NFTS_ERROR,
  FETCH_ACCOUNT_COLLECTION_NFTS_LOADING,
  FETCH_ACCOUNT_COLLECTION_NFTS_SUCCESS,
  REVOKE_ACC_CURRENT_NFT_SUCCESS,
  TRANSFER_ACCOUNT_COLLECTION_NFT,
  UPDATE_ACCOUNT_COLLECTION_NFT,
  WITHDRAW_ACC_CURRENT_NFT_SUCCESS
} from '../ActionTypes';
import { INft } from 'interfaces/Nft';

type InitialStateType = {
  loading: boolean;
  loaded: boolean;
  error: string;
  data: INft[];
  meta: IMeta;
};

export const INIT_STATE: InitialStateType = {
  loading: false,
  loaded: false,
  error: '',
  data: [],
  meta: defaultMeta
};

export const AccountCollectionNftsReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_ACCOUNT_COLLECTION_NFTS_LOADING:
        draft.loading = true;
        draft.loaded = false;
        draft.error = '';
        break;

      case FETCH_ACCOUNT_COLLECTION_NFTS_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        if (action.payload.meta.current_page === 1) {
          draft.data = action.payload.data;
        } else {
          draft.data.push(...action.payload.data);
        }
        draft.meta = action.payload.meta;
        break;

      case FETCH_ACCOUNT_COLLECTION_NFTS_ERROR:
        draft.loading = false;
        draft.loaded = true;
        draft.error = action.payload;
        break;

      case CLEAR_ACCOUNT_COLLECTION_NFTS_DATA:
        draft.loading = false;
        draft.loaded = true;
        draft.data = [];
        break;
      case REVOKE_ACC_CURRENT_NFT_SUCCESS: {
        const updateIndex = draft.data.findIndex(
          item => item.id === action.payload.id
        );
        draft.data[updateIndex] = action.payload;
        break;
      }
      case WITHDRAW_ACC_CURRENT_NFT_SUCCESS: {
        const index = draft.data.findIndex(item => item.id === action.payload);
        draft.data.splice(index, 1);
        break;
      }
      case ADD_ACCOUNT_COLLECTION_NFT: {
        draft.data.unshift(action.payload);
        break;
      }
      case DELETE_ACCOUNT_COLLECTION_NFT: {
        draft.data = draft.data.filter(elem => elem.id !== action.payload);
        break;
      }
      case UPDATE_ACCOUNT_COLLECTION_NFT: {
        draft.data = draft.data.map(elem => {
          if (elem.id === action.payload.id) {
            return action.payload;
          }
          return elem;
        });
        break;
      }
      case TRANSFER_ACCOUNT_COLLECTION_NFT: {
        draft.data = draft.data.filter(elem => elem.id !== action.payload);
        break;
      }
    }
  });
